import React, { useState } from 'react';
import './WebBrowser.css';

const WebBrowser = () => {
  const [url, setUrl] = useState('https://oldgoogle.neocities.org/1998/');
  const [inputValue, setInputValue] = useState(url);

  const handleGo = () => {
    // Prepend "http://" if missing (a basic check)
    const formattedUrl = inputValue.startsWith('http') ? inputValue : `http://${inputValue}`;
    setUrl(formattedUrl);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleGo();
    }
  };

  return (
    <div className="web-browser">
      <div className="address-bar">
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter URL..."
        />
        <button onClick={handleGo}>Go</button>
      </div>
      <div className="browser-content">
        <iframe src={url} title="Web Browser" frameBorder="0" />
      </div>
    </div>
  );
};

export default WebBrowser;
